export default __webpack_public_path__ + "static/clue-71d35748f87f87676ed29b62b76a8311.png";